import { useEffect } from 'react';
import pageMetadata from '@/lib/pageMetadata.json';
import { useLocation } from 'react-router-dom';
import { useLang } from '@/i18n/LanguageContext';

export const SITE_ORIGIN = pageMetadata.siteOrigin;
export const DEFAULT_IMAGE = SITE_ORIGIN + pageMetadata.defaultImage;
const records = new Map();
const EVENT = 'plantadopting:page-seo';
export const cleanText = value => typeof value === 'string' ? value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() : '';
export function seoModel(pathname, lang, metadata = {}) {
  const title = cleanText(metadata.title) || (lang === 'it' ? 'Patrimonio vivente' : 'Living heritage');
  const description = (cleanText(metadata.description) || (lang === 'it' ? 'Scopri soggetti, territori e progetti del patrimonio vivente con PlantAdopting.' : 'Discover subjects, territories and living heritage projects with PlantAdopting.')).slice(0, 180);
  let image = DEFAULT_IMAGE;
  try { const candidate = new URL(metadata.image || '', SITE_ORIGIN); if (metadata.image && candidate.protocol === 'https:') image = candidate.href; } catch { /* Keep the official fallback. */ }
  const privateRoute = /^\/(dashboard|payments|login|register|list-your-farm)(\/|$)/.test(pathname) || pathname === '/support/contribute';
  return {title: title + ' | PlantAdopting', description, image,
    canonical: SITE_ORIGIN + (pathname === '/' ? '/' : pathname.replace(/\/+$/, '')),
    robots: privateRoute || metadata.noindex ? 'noindex, follow' : 'index, follow',
    locale: lang === 'it' ? 'it_IT' : 'en_GB'};
}
export function applySeo(model) {
  document.title = model.title;
  const meta = (attribute, name, content) => {
    let el = document.head.querySelector('meta[' + attribute + '="' + name + '"]');
    if (!el) { el = document.createElement('meta'); el.setAttribute(attribute, name); document.head.appendChild(el); }
    el.content = content;
  };
  meta('name', 'description', model.description);
  meta('name', 'robots', model.robots);
  for (const [key, value] of Object.entries({title:model.title,description:model.description,image:model.image,url:model.canonical,type:'website',site_name:'PlantAdopting',locale:model.locale})) meta('property','og:' + key,value);
  for (const [key,value] of Object.entries({card:'summary_large_image',title:model.title,description:model.description,image:model.image})) meta('name','twitter:' + key,value);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
  canonical.href = model.canonical;
}
export function routeSeo(pathname, lang) { return records.get(pathname + ':' + lang); }
export function usePageSeo(metadata) {
  const {pathname} = useLocation(); const {lang} = useLang();
  const {title,description,image,noindex} = metadata;
  useEffect(() => {
    const key = pathname + ':' + lang;
    const value = {title,description,image,noindex};
    records.set(key,value); window.dispatchEvent(new Event(EVENT));
    return () => { if (records.get(key) === value) records.delete(key); };
  }, [pathname,lang,title,description,image,noindex]);
}
export const SEO_EVENT = EVENT;
